var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"canvas-container"},[_c('canvas',{ref:"canvas",attrs:{"id":"my-canvas"}}),_c('div',{staticClass:"slot-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }